(() => {
  const rootLanguage = (document.documentElement.lang || '').toLowerCase();
  if (!rootLanguage.startsWith('fr')) return;

  const euroBeforeAmount = /€[\s\u00a0\u202f]*([0-9]+(?:[\s\u00a0\u202f.]?[0-9]{3})*(?:,[0-9]{2})?)/g;
  const ignoredParents = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'NOSCRIPT']);

  const formatTextNode = (node) => {
    if (!node?.nodeValue || ignoredParents.has(node.parentElement?.tagName)) return;
    const updated = node.nodeValue.replace(euroBeforeAmount, '$1 €');
    if (updated !== node.nodeValue) node.nodeValue = updated;
  };

  const formatTree = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) formatTextNode(node);
  };

  const start = () => {
    formatTree(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') formatTextNode(mutation.target);
        for (const addedNode of mutation.addedNodes) formatTree(addedNode);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
